var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-card-item"},[_c('dd',[_c('b',[_vm._t("head")],2)]),_c('dd',[_c('small',[_vm._t("body")],2)]),_c('dd',[_vm._t("footer")],2),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }